// BuddyPix Product Page Integration
// 1. Intercepts Horizon's zoom-dialog to display BuddyPix artwork
// 2. Syncs first carousel thumbnail with BuddyPix artwork

(function() {
  'use strict';

  function getBuddyPixImage() {
    // Check both sources: gallery selection OR new generation
    return window.buddyPixCurrentImage || sessionStorage.getItem('generatedImageUrl');
  }

  // --- Lightbox Intercept ---
  customElements.whenDefined('zoom-dialog').then(() => {
    const ZoomDialog = customElements.get('zoom-dialog');
    const originalOpen = ZoomDialog.prototype.open;

    ZoomDialog.prototype.open = async function(index, event) {
      const buddyPixUrl = getBuddyPixImage();

      if (buddyPixUrl && index === 0) {
        const dialog = this.refs.dialog;
        if (dialog) {
          const dialogGallery = dialog.querySelector('.dialog-zoomed-gallery');
          if (dialogGallery) {
            const firstMediaContainer = dialogGallery.querySelector('li');
            if (firstMediaContainer) {
              const img = firstMediaContainer.querySelector('img.product-media__image');
              if (img) {
                img.src = buddyPixUrl;
                img.srcset = '';
                img.removeAttribute('sizes');
                img.setAttribute('data_max_resolution', buddyPixUrl);
              }
            }
          }

          const thumbnailsList = dialog.querySelector('.dialog-thumbnails-list');
          if (thumbnailsList) {
            const firstThumbnail = thumbnailsList.querySelector('button');
            if (firstThumbnail) {
              const thumbImg = firstThumbnail.querySelector('img');
              if (thumbImg) {
                thumbImg.src = buddyPixUrl;
                thumbImg.srcset = '';
                thumbImg.removeAttribute('sizes');
              }
            }
          }
        }
      }

      return originalOpen.call(this, index, event);
    };
  });

  // --- Frame compositing mode detection ---
  // When artif-frame-switcher.js is active (generative products), it handles
  // variant change artwork persistence. This script skips its own patching.
  function isFrameCompositingMode() {
    return !!document.getElementById('artif-artwork-display');
  }

  // --- Patch artwork into variant update HTML before gallery replacement ---
  // Intercepts the variant:update event in the capture phase, so the new
  // <media-gallery> HTML already contains the artwork when replaceWith() runs.
  // This eliminates the flash of the original product image.
  function patchVariantHtml(event) {
    // Let artif-frame-switcher.js handle generative products
    if (isFrameCompositingMode()) return;

    var buddyPixUrl = window.buddyPixCurrentImage;
    if (!buddyPixUrl) return;

    var html = event.detail && event.detail.data && event.detail.data.html;
    if (!html) return;

    var newGallery = html.querySelector('media-gallery');
    if (!newGallery) return;

    // Patch the first slide's main image
    var firstImg = newGallery.querySelector('slideshow-slide:first-child img.product-media__image');
    if (firstImg) {
      firstImg.src = buddyPixUrl;
      firstImg.srcset = '';
      firstImg.removeAttribute('sizes');
    }

    // Patch the first thumbnail
    var firstThumbImg = newGallery.querySelector('.slideshow-controls__thumbnail:first-child img');
    if (firstThumbImg) {
      firstThumbImg.src = buddyPixUrl;
      firstThumbImg.srcset = '';
      firstThumbImg.removeAttribute('sizes');
    }
  }

  // --- Carousel Thumbnail Sync ---
  function syncFirstThumbnail() {
    // Frame compositing mode: first slide has no img.product-media__image
    if (isFrameCompositingMode()) return;

    var gallery = document.querySelector('media-gallery');
    if (!gallery) return;

    var firstSlideImg = gallery.querySelector('slideshow-slide:first-child img.product-media__image');
    var firstThumbBtn = gallery.querySelector('.slideshow-controls__thumbnail:first-child');
    if (!firstSlideImg || !firstThumbBtn) return;

    var firstThumbImg = firstThumbBtn.querySelector('img');
    if (!firstThumbImg) return;

    // Clone the entire original <img> element for clean restoration later
    // This preserves src, srcset, sizes, alt, loading, style — everything
    if (!firstThumbBtn._originalImgClone) {
      firstThumbBtn._originalImgClone = firstThumbImg.cloneNode(true);
    }

    // Watch for any src change on the main slide image (handles select/deselect)
    new MutationObserver(function() {
      var buddyPixUrl = getBuddyPixImage();
      var newSrc = firstSlideImg.src;

      if (buddyPixUrl && newSrc === buddyPixUrl) {
        // Artwork applied — sync thumbnail
        firstThumbImg.src = buddyPixUrl;
        firstThumbImg.srcset = '';
        firstThumbImg.removeAttribute('sizes');
      } else if (!window.buddyPixCurrentImage) {
        // No artwork active — don't interfere with app's restoration
        return;
      }
    }).observe(firstSlideImg, { attributes: true, attributeFilter: ['src'] });

    // Apply immediately if main image already shows artwork
    var buddyPixUrl = getBuddyPixImage();
    if (buddyPixUrl && firstSlideImg.src === buddyPixUrl) {
      firstThumbImg.src = buddyPixUrl;
      firstThumbImg.srcset = '';
      firstThumbImg.removeAttribute('sizes');
    }
  }

  // Re-attach after variant change replaces <media-gallery>
  function initSync() {
    syncFirstThumbnail();

    var section = document.querySelector('media-gallery')?.closest('.shopify-section');
    if (section) {
      // Capture-phase listener patches artwork into new HTML BEFORE media-gallery replaces itself
      section.addEventListener('variant:update', patchVariantHtml, true);

      // Re-attach thumbnail sync observer after DOM replacement
      new MutationObserver(function() {
        if (document.querySelector('media-gallery')) {
          setTimeout(syncFirstThumbnail, 50);
        }
      }).observe(section, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSync);
  } else {
    initSync();
  }
})();
